import { Action, createReducer, on } from '@ngrx/store';
import {
    fetchRecords,
    fetchRecordsSuccess,
    fetchRecordsFail,
    resetState,
    fetchSingleRecordSuccess
} from './dossier-invoice.action';

import { DossierInvoices, Templates } from './dossier-invoice.model';
import { PaymentType } from '../PaymentType/payment-type.model';

export interface DossierInvoicesRecordsState {
    listData: any[];
    paymentTypes: PaymentType[];
    total: number;
    singleData: DossierInvoices;
    loading: boolean;
    error: any;
}

export const initialState: DossierInvoicesRecordsState = {
    listData: [],
    paymentTypes: [],
    total: 0,
    singleData: null,
    loading: false,
    error: null,
};


export const DossierInvoicesRecordReducer = createReducer(

    initialState,

    // All Records
    on(fetchRecords, (state) => {
        return { ...state, loading: true, error: null };
    }),
    on(fetchRecordsSuccess, (state, { listData, total }) => {
        return { ...state, listData, total, loading: false };
    }),
    on(fetchRecordsFail, (state, { error }) => {
        return { ...state, error, loading: false };
    }),

    // Single record
    on(fetchSingleRecordSuccess, (state, { singleData, paymentTypes }) => {
        return { ...state, singleData, paymentTypes, error: null };
    }),

    //Reset State
    on(resetState, () => initialState)  // Reset action handler
);